import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ScreenShareIcon } from '@streamr/tv-ui';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { MediaService } from '../../../services/media/MediaService';
import { Anchor } from '../../Anchor';
import { selectShareScreenSource } from '../../popups/ShareScreenPopup';
export function ShareScreenButton(props) {
    const { className } = props;
    const [isShareScreenPopupOpen, setIsShareScreenPopupOpen] = useState(false);
    const shareScreenButtonAnchorRef = useRef(null);
    const mediaService = MediaService.getNotificationInterface();
    const { isSharingScreen } = MediaService.getOutput().useMediaStreamData();
    return (_jsx(ShareScreenButtonAnchor, { ref: shareScreenButtonAnchorRef, children: isSharingScreen ? (_jsx(ShareScreenButtonRoot, { className: className, type: "button", onClick: () => {
                mediaService.notifyScreenShareStopped();
            }, children: "Stop sharing" })) : (_jsx(ShareScreenButtonRoot, { "$isShareScreenPopupOpen": isShareScreenPopupOpen, className: className, type: "button", onClick: () => {
                selectShareScreenSource({
                    anchorRef: shareScreenButtonAnchorRef,
                    onOpenPopup: () => {
                        setIsShareScreenPopupOpen(true);
                    },
                    onClosePopup: () => {
                        setIsShareScreenPopupOpen(false);
                    },
                });
            }, children: _jsx(ScreenShareIcon, { fill: "currentColor", size: "x1_5" }) })) }));
}
const ShareScreenButtonAnchor = styled(Anchor) ``;
const ShareScreenButtonRoot = styled(Button) `
    height: 3rem;
    min-width: 3rem;
    --Button_Background: ${({ $isShareScreenPopupOpen }) => ($isShareScreenPopupOpen ? 'var(--tv-ui-color-3)' : 'var(--tv-ui-color-4)')};
    --Button_HoverBackground: ${({ $isShareScreenPopupOpen }) => ($isShareScreenPopupOpen ? 'var(--tv-ui-color-3)' : 'var(--tv-ui-color-4)')};
    --Button_TextColor: ${({ $isShareScreenPopupOpen }) => ($isShareScreenPopupOpen ? 'var(--tv-ui-color-1)' : 'var(--tv-ui-color-3)')};
    --Button_Padding: 0 1.5rem;
    backdrop-filter: blur(10px);
    transform-origin: center;
    border-radius: 1.5rem;
    will-change: transform;
`;
